import axios from 'axios';


const backendApi = axios.create({
  // baseURL: "http://localhost:8080/domino/"
 baseURL: window.location.protocol+"//"+window.location.hostname+"/domino/"
});


const getJwtToken = async () => {
  const token = await localStorage.getItem("token");
  return token;
};

backendApi.interceptors.request.use(

  async (request) => {
    const token = await getJwtToken();
    if (token) {
      request.headers['Authorization'] = 'Bearer ' + token;
    }
    if (process.env.NODE_ENV === 'development' && request.url?.includes('/api/production-chat/')) {
      request.chatTimingStartedAt = performance.now();
      console.info('[Chat timing] start', request.method?.toUpperCase(), request.url);
    }
    return request;
  }

);

// Development diagnostics include only route, status and elapsed time.
const logChatTiming = (config, status) => {
  if (process.env.NODE_ENV !== 'development' || config?.chatTimingStartedAt === undefined) return;
  console.info('[Chat timing] complete', JSON.stringify({
    method: config.method?.toUpperCase(), path: config.url, status,
    durationMs: Math.round(performance.now() - config.chatTimingStartedAt)
  }));
};
backendApi.interceptors.response.use(response => {
  logChatTiming(response.config, response.status);
  return response;
}, error => {
  logChatTiming(error.config, error.response?.status || 'network-error');
  return Promise.reject(error);
});

export { getJwtToken };
export default backendApi;


